<template>
    <div id="i-collaboratori" class="section collaboratori beige" v-if="this.dataLoaded">
        <GridLines />
        <div class="big-title" v-if="this.page.attributes.title" data-aos="new-animation" data-aos-init="aos-init">
            <h1 v-html="this.splittedTitle(this.page.attributes.title)"></h1>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-lg-6">
                    <div class="images-container" data-aos="new-animation" data-aos-init="aos-init">
                        <!-- <div class="image-container statua" data-aos="new-animation" data-aos-init="aos-init"
                            data-aos-delay="1000">
                            <div class="image-container-outer">
                                <div class="image-container-inter">
                                    <img src="../assets/collaboratori-image-1.png" alt="">
                                </div>
                            </div>
                        </div> -->
                        <div class="image-container studio" data-aos="new-animation" data-aos-init="aos-init"
                            data-aos-delay="2000">
                            <div class="image-container-outer">
                                <div class="image-container-inter">
                                    <img src="../assets/collaboratori-image-2.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6">
                    <h3>il team</h3>
                    <h1 data-aos="new-animation" v-if="page.attributes.title" data-aos-init="aos-init"
                        class="animated-title" data-aos-delay="4000" v-html="this.page.attributes.title"></h1>
                    <p style="display:none;" v-html="this.page.attributes.field_description.processed"></p>
                    <div class="partner" v-if="this.partnersImages">
                        <div class="" v-for="(partner, index) in partners" :key="partner.id">
                            <div class="row" v-if="index >= 2">
                                <div class="col-sm-12 col-md-4  image">
                                    <img data-toggle="collapse" width="170"
                                        :href="'#asd'+partner.id" :src="'https://ptnlex-api-prod.interfase.tv/'+partner.imageUrl" alt="">
                                </div>
                                <div class="col-sm-12 col-md-8">
                                    <h2 v-if="partner.attributes.title" data-toggle="collapse"
                                        :href="'#asd'+partner.id">{{partner.attributes.title}}</h2>
                                    <a class="btn btn-primary read-more" data-toggle="collapse"
                                        :href="'#asd'+partner.id" role="button" aria-expanded="false">{{labelReadMore}}</a>
                                </div>
                                <div class="collapse description" :id="'asd'+partner.id">
                                    <p class="card card-body"
                                        v-html="partner.attributes.field_description.processed">
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
    import GridLines from "./GridLines.vue"

    export default {
        name: 'section-collaboratori',
        components: {
            GridLines
        },
        props: {
            dataPages: {
                type: String
            },
            dataParnters: {
                type: String
            }
        },
        data: () => {
            return {
                idIntroPage: "42bc6e07-7534-4a7e-86bf-88049238ca16",
                page: [],
                dataLoaded: false,
                partners: [],
                partnersImages: []
            }
        },
        computed:{
            labelReadMore(){
                let label;
                if(this.$route.params.lang == "it"){
                label = "Maggiori informazioni"
            } else {
                label = "Read more"
                }
                return label
            }
        },
        methods: {
            splittedTitle: function (value) {
                return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
            },
            findObjectbyKey(array, key, value) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i][key] === value) {
                        return array[i];
                    }
                }
                return null;
            },
            loadDataImages() {
                this.partners.forEach((e, index) => {
                    let imageUrls = e.relationships.field_picture.links.related.href;

                    fetch(imageUrls, {
                            method: "GET",
                            mode: 'cors'
                        })
                        .then(response => {
                            return response.json()
                        })
                        .then(json => {
                            this.partnersImages = json.data
                            this.partners[index].imageUrl = this.partnersImages.attributes.uri.url
                            if (index == 2) {
                                this.dataLoaded = true
                            }
                        })
                        .catch(function (error) {
                            console.log('Request failed', error)
                        });
                });
            }
        },
        mounted() {
            fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {
                    method: "GET",
                    mode: 'cors'
                })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    this.page = this.findObjectbyKey(json.data, "id", this.idIntroPage)
                    this.dataLoaded = true
                })
                .catch(function (error) {
                    console.log('Request failed', error)
                });

            fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/partner", {
                    method: "GET",
                    mode: 'cors'
                })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    this.partners = json.data
                    this.loadDataImages()
                })
                .catch(function (error) {
                    console.log('Request failed', error)
                });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.partner h2,.partner img{
    cursor: pointer;
}
    .collaboratori {
        height: 100%;

        .container {
            padding-top: 9rem;
            padding-bottom: 11rem;
        }
        .images-container {
            .studio {
                width: 470px;
                height: 508px;
                transform: translate(0%, 0%);
            }
            .statua {
                width: 260px;
                height: 260px;
                transform: translate(90%, 112%);
                z-index: 99;
            }
        }
    }

    .collaboratori .big-title {
        z-index: 0;
        h1 {
            transform: translate3d(120%, 583%, 0);
        }
    }

    .partner {
        margin-top: 2rem;
    }

    .card{
        padding: 2rem 16px;
    }
    .collaboratori {
        min-height: 100vh;

    }
    @media (max-width:1366px) {
        .images-container {
            transform: scale(0.8);
            transform-origin: left;
        }

        .image img {
            width: 100%;
        }
    }

    @media (max-width:992px) {
        .collaboratori .container {
            padding-top: 4rem;
            padding-bottom: 4rem;
        }
        .collaboratori {
         min-height: none;
        }
    }
</style>